export function hasProfileSecret(person:{username?:string;displayName?:string;bot?:boolean}|null|undefined){
 return !!person&&!person.bot&&[person.username,person.displayName].some(value=>['lukas','lukasbeppi'].includes(String(value||'').normalize('NFKC').trim().toLowerCase()));
}
export function createSecretGate(cooldownMs=2000){let last=-Infinity;return (at:number)=>{if(!Number.isFinite(at)||at-last<cooldownMs)return false;last=at;return true;};}
